"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const defaultElementAnimation_1 = __importDefault(require("./defaultElementAnimation"));
const element_1 = require("../types/element");
function defaultImageElement(src) {
    return {
        id: (0, nanoid_1.nanoid)(8),
        mediaType: 0,
        visible: true,
        isNew: true,
        active: false,
        playing: false,
        previewing: false,
        lock: false,
        type: element_1.ELEMENT_TYPE.IMAGE,
        src,
        angle: 0,
        x: 50,
        y: 50,
        width: 681,
        height: 528,
        externalLink: {
            isActive: false,
            value: '',
            elementName: '',
        },
        file: {
            originalWidth: 681,
            originalHeight: 528,
            fileName: 'image_placeholder',
        },
        shadow: {
            x: 0,
            y: 0,
            color: '#000000',
            blur: 0,
        },
        boxShadow: '0',
        opacity: 100,
        flipX: 1,
        flipY: 1,
        animationsTimeline: [(0, defaultElementAnimation_1.default)()],
    };
}
exports.default = defaultImageElement;
